import { isEmpty } from '../utilities/general'
import camelcaseKeys from 'camelcase-keys'
import { addSessionExpiry } from '../utilities/session'
import { RealtimePostgresChangesPayload } from '@supabase/realtime-js'
import { Database } from '../types/supabase'
import { supabase } from '../supabaseClient'
import { create } from 'zustand'

export interface SessionState {
  sessions: Session[]
  set: (state: Partial<SessionState>) => void
  get: () => Promise<void>
  add: (session: Session) => void
  update: (session: Partial<Session>) => void
  remove: (sessionId?: string) => void
  subscribe: () => () => void
  reset: () => void
}

const state = {
  sessions: [],
}

const useSession = create<SessionState>()((set, get) => ({
  ...state,
  set,
  get: async () => {
    const { data, error } = await supabase.from('app_latest_sessions').select('*')
    if (error) console.warn(error)
    else {
      const sessions = (camelcaseKeys(data) as Session[]).map(addSessionExpiry)
      console.log('get sessions', sessions)
      set({ sessions })
    }
  },
  add: session => {
    const sessions = [...get().sessions]
    sessions.push(addSessionExpiry(session))
    set({ sessions })
  },
  update: session => {
    const { id, ...data } = session
    const sessions = [...get().sessions]

    const index = sessions.findIndex(n => n.id === id)
    if (index === -1) {
      sessions.push(addSessionExpiry(session as Session))
    } else if (isEmpty(data)) {
      sessions.splice(index, 1)
    } else {
      sessions[index] = addSessionExpiry({ ...sessions[index], ...session })
    }

    set({ sessions })
  },
  remove: sessionId => {
    let sessions = [...get().sessions]
    sessions = sessions.filter(n => n.id !== sessionId)
    set({ sessions })
  },
  subscribe: () => {
    const { add, update, remove } = get()

    const subscription = supabase
      .channel('sessions-all')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'sessions' },
        async (payload: RealtimePostgresChangesPayload<Database['public']['Tables']['sessions']['Row']>) => {
          console.log('Session received!', payload.eventType, payload.new)
          const session = camelcaseKeys(payload.new) as Session
          switch (payload.eventType) {
            case 'INSERT':
              add(session)
              break
            case 'UPDATE':
              update(session)
              break
            case 'DELETE':
              remove(payload.old.id)
              break
          }
        }
      )
      .subscribe()

    return () => {
      console.log('Unsubscribing from session changes')
      supabase.removeChannel(subscription)
    }
  },
  reset: () => {
    set({ ...state })
  },
}))

export default useSession
